import React from 'react';
import EnvironmentSelector from './EnvironmentSelector';
import AppSelector from './AppSelector';
import TimeWindowPicker from './TimeWindowPicker';
import { spacing } from '../utils/designTokens';

/**
 * GlobalSelectors component renders the three global context selectors:
 * - Environment (dev/staging/prod)
 * - Application (always shown, active=true enables dropdown, active=false disables it)
 * - Time Window (last 24h, etc.)
 *
 * Used in TabbedPageLayout and ListPageLayout to provide consistent
 * selector placement in the page header.
 *
 * @param {boolean} activeAppSelector - If true, app selector is active/clickable. If false, disabled/grayed (Home page)
 */
const GlobalSelectors = ({ activeAppSelector = true }) => {
  // Validate required props
  if (typeof activeAppSelector !== 'boolean') {
    throw new Error('GlobalSelectors activeAppSelector prop must be boolean');
  }

  return (
    <div className="flex items-center gap-2.5">
      <EnvironmentSelector />
      <AppSelector forceDisabled={!activeAppSelector} />
      <TimeWindowPicker />
    </div>
  );
};

export default GlobalSelectors;
